import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { PublicAccountShellComponent } from '../public-account-shell/public-account-shell.component';

export type LegalDocument = 'terms';

/**
 * Publieke juridische pagina (de voorwaarden). De privacyverklaring staat centraal op de
 * landing, zie privacy-statement.ts.
 * De inhoud komt volledig uit de vertaalbestanden (account.legal.*),
 * zodat NL/EN en latere aanpassingen geen code-wijziging vragen.
 */
@Component({
  selector: 'legal-page',
  imports: [TranslocoModule, RouterLink, PublicAccountShellComponent],
  templateUrl: './legal-page.component.html',
  styleUrl: './legal-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LegalPageComponent {
  private readonly route = inject(ActivatedRoute);

  /** Welke juridische tekst getoond wordt; gezet via route data. */
  protected readonly document: LegalDocument = this.route.snapshot.data['document'] ?? 'terms';

  protected readonly baseKey = `account.legal.${this.document}`;

  protected readonly sectionIndexes = [1, 2, 3, 4, 5, 6];
}
